import React from "react";
import BreadCrumb from "../../../../layout/BreadCrumb";
import placeholderImg from "../../../../assets/img/placeholderImg.png";
import svg32 from "../../../../assets/svg/svg32.svg";
import svg33 from "../../../../assets/svg/svg33.svg";
import svg35 from "../../../../assets/svg/svg35.svg";
import { useNavigate } from "react-router-dom";
import { Avatar, Descriptions, Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setActiveObj } from "../../../../features/obj/objSlice";
import { formatImgPath, getColorFromName, getInitials } from "../../../../utils";

function UserViewList() {
  const dispatch = useDispatch();
  const { activeObjUser } = useSelector((state) => ({
    activeObjUser: state.obj.activeObj["usersData"],
  }));
  const navigate = useNavigate();
  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "usersData", data: activeObjUser }));
    await navigate("/user/user-add");
  };
  const items1 = [
    {
      key: "1",
      label: "Email",
      children: activeObjUser?.email ?? "N/A",
    },
    {
      key: "5",
      label: "Department",
      children: activeObjUser?.usrDepartment ?? "N/A",
    },
    {
      key: "2",
      label: "Status",
      children: activeObjUser?.usrUserStatus ?? "N/A",
    },
  ];
  const items2 = [
    {
      key: "2",
      label: "National ID",
      children: activeObjUser?.usrNationalId ?? "N/A",
    },
    {
      key: "3",
      label: "Mobile Number",
      children: activeObjUser?.phoneNumber ?? "N/A",
    },
    {
      key: "4",
      label: "Profile",
      children: activeObjUser?.usrProfile ?? "N/A",
    },
  ];
  return (
    <div className="min-h-[88vh] flex flex-col ">
      <BreadCrumb
        breadcrumbs={[
          { title: "Users", path: "/user/users-list" },
          { title: "User View" },
        ]}
      />

      <div className="white_card mt-[2.06rem] flex-1 min-h-[50vh]">
        <div className="flex items-center justify-between">
          <div className="gap-x-[2.5rem] flex">
            {
              activeObjUser?.usrLogo ? (
                <div className="w-[5rem] h-[5rem] rounded-full">
                <img
                  className="w-full h-full"
                  src={formatImgPath(activeObjUser?.usrLogo)}
                  alt="placeholderImg"
                />
              </div>
              ):(
                <Avatar style={{ backgroundColor: getColorFromName(activeObjUser?.fullNames) }}>{getInitials(activeObjUser?.fullNames)}</Avatar>
              )
            }
            

            <div className="flex flex-col  gap-y-[.62rem]">
              <span className="form-add-h">{activeObjUser?.fullName}</span>
              <div className="flex items-center gap-x-[.62rem]">
                <div className="flex items-center gap-x-1">
                  <img src={svg32} alt="svg32" />
                  <span className="typography_2 ">
                    {activeObjUser?.usrProfile}
                  </span>
                </div>

                <div className="flex items-center gap-x-1">
                  <img src={svg33} alt="svg33" />
                  <span className="typography_2">
                    {activeObjUser?.usrDepartment}
                  </span>
                </div>

                <div className="flex items-center">
                  <span className="forgot-text !text-[#706F6F] bg-[#F1F3F5] rounded-[.375rem] max-w-[6.875rem] justify-center flex items-center py-[.125rem] px-[.25rem]">
                    {activeObjUser?.usrUserStatus}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={() => handleEdit()}
            className="cstm-btn-2 gap-x-[.5rem] !w-[100px]"
          >
            <img src={svg35} alt="svg35" />
            <span className="">Edit</span>
          </button>
        </div>

        <div className="details_h mt-[3rem]">Information</div>

        <div className="mt-[1.25rem]">
          <Divider />
        </div>
        <div className="flex lg:flex-row flex-col gap-y-10 mt-[2rem]">
          <Descriptions column={1} colon={false} items={items1} />
          <Descriptions column={1} colon={false} items={items2} />
        </div>
      </div>
    </div>
  );
}

export default UserViewList;
